<ng-container
  *ngIf="{
    responseId: responseId$ | async
  } as data"
>
  <cng-contact-view-layout>
    <ng-template cngContactViewLayoutActions>
      <chat-qualification-actions [responseId]="data.responseId"></chat-qualification-actions>
    </ng-template>
    <ng-template cngContactViewLayoutWorkspace>
      <chat-qualification [responseId]="data.responseId"></chat-qualification>
    </ng-template>
  </cng-contact-view-layout>
</ng-container>
